import styled from "styled-components";
import { TreeSelect } from "@components/tree-select";

export const StyledTreeSelect = styled(TreeSelect)`
  width: 100%;
  & .ant-select-selection-placeholder {
    color: ${({ theme }) => theme.darkGrey};
  }
` as any as typeof TreeSelect;
